import { Button, useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useEffect, useMemo, useState } from 'react'
import { Else, If, Then, When } from 'react-if'

import { PROFILE_IMAGE_TYPE } from '../../Queries/utils'
import CustomModal from '../../Theme/Modal'
import { BREAKPOINT_MIN_SM } from '../../Theme/stylesUtil'
import { userImageSelector } from '../../utils/user-images-utils'
import UserCard from '../_common/UserCard'
import MainSwipeableDrawer from '../Mobile/MainSwipableDrawer'
import { JudgesModal } from './ContestCreate/ContestPreview/JudgesModal'
import ContestJudgesBioModal from './InvitationSteps/ContestJudgesBioModal'

// TODO need skeleton and isLoading prop
const ContestJudgesList = ({
  judges = [],
  isJudge = false,
  isPreview = false,
  isOwner = false,
  isPublishedRound = false,
  contestId,
  ownerId,
  contest,
  contestRelation,
}) => {
  const [showModal, setShowModal] = useState(false)
  const [activeTab, setActiveTab] = useState({})

  useEffect(() => {
    if (judges.length > 0 && !activeTab?.id) {
      setActiveTab(judges[0])
    }
  }, [activeTab, judges])

  const activeJudgeInfo = useMemo(() => {
    if (!contestRelation?.contest_judges && !contestRelation?.maps && !contestRelation?.users) return
    const judgesArr = judges.map((judge) => judge.judge_id).map((id) => contestRelation.contest_judges[id])
    const usersMapsArr = Object.values(contestRelation.maps || {})
    const usersArr = Object.values(contestRelation.users)

    const judgeData = judgesArr && judgesArr.find((judge) => activeTab.user_id === judge.user_id)
    const userMapsFiltered = usersMapsArr.filter((map) => map.user_id === activeTab.user_id)
    const userData = usersArr.find((user) => user.id === activeTab.user_id)

    const favoriteMaps =
      judgeData?.judge_favorite_maps?.length > 0 &&
      judgeData.judge_favorite_maps.map((map) => ({
        ...contestRelation.maps[map.map_id],
        user: contestRelation.users[contestRelation.maps[map.map_id]?.user_id],
      }))

    const originalMaps =
      judgeData?.judge_original_maps?.length > 0 &&
      judgeData.judge_original_maps.map((map) => ({
        ...contestRelation.maps[map.map_id],
        user: contestRelation.users[contestRelation.maps[map.map_id]?.user_id],
      }))

    const userMaps =
      userMapsFiltered.length > 0 &&
      userMapsFiltered.map((map) => ({
        ...map,
        user: contestRelation.users[contestRelation.maps[map.id]?.user_id],
      }))

    return { ...judgeData, userMaps, userData, favoriteMaps, originalMaps }
  }, [activeTab?.user_id, contestRelation?.contest_judges, contestRelation?.maps, contestRelation?.users, judges])

  const isBiggerThanSMScreen = useMediaQuery(BREAKPOINT_MIN_SM)
  const [showJudgesBio, setShowJudgesBio] = useState(false)
  const showEditBtn = isOwner && !isPreview

  const closeJudgesBio = () => {
    setShowJudgesBio(false)
  }

  return (
    !!judges.length && (
      <Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
        >
          <Typography
            variant="h6"
            color="text.secondary"
          >
            Contest Judges
          </Typography>
          {showEditBtn && (
            <Button
              variant="text"
              color="secondary"
              onClick={() => setShowModal(true)}
            >
              Edit
            </Button>
          )}
          <When condition={!!activeJudgeInfo}>
            <Button
              variant="text"
              color="secondary"
              onClick={() => setShowJudgesBio(true)}
            >
              Judges bio
            </Button>
          </When>

          <When condition={showJudgesBio}>
            <If condition={isBiggerThanSMScreen}>
              <Then>
                <CustomModal
                  open={showJudgesBio}
                  onClose={closeJudgesBio}
                  fullWidth={true}
                  withPadding={false}
                  exitButtonStyle={{ top: '12px' }}
                  gap={0}
                  modalPadding={'48px'}
                  sx={{
                    width: '100%',
                    padding: '0px',
                    '& .MuiDialog-container': {
                      padding: 0,
                      '& .MuiPaper-root': {
                        padding: 0,
                        maxWidth: '1200px',
                      },
                    },
                  }}
                >
                  <ContestJudgesBioModal
                    judges={judges}
                    user={activeJudgeInfo?.userData}
                    favoriteMaps={activeJudgeInfo?.favoriteMaps}
                    originalMaps={activeJudgeInfo?.originalMaps}
                    isUserFetched={!!activeTab?.id}
                    userMaps={activeJudgeInfo?.userMaps}
                    bio={activeJudgeInfo?.bio}
                    designPreference={activeJudgeInfo?.design_preferences}
                    loveAboutHalo={activeJudgeInfo?.love_about_halo}
                    isPreview={false}
                    setActiveJudge={setActiveTab}
                    contestRelation={contestRelation}
                    judgeState={activeJudgeInfo?.state}
                    contestId={contestId}
                  />
                </CustomModal>
              </Then>
              <Else>
                <MainSwipeableDrawer
                  drawerHeight={'100vh'}
                  isOpenDrawer={showJudgesBio}
                  setIsOpenDrawer={setShowJudgesBio}
                >
                  <ContestJudgesBioModal
                    judges={judges}
                    user={activeJudgeInfo?.userData}
                    favoriteMaps={activeJudgeInfo?.favoriteMaps}
                    originalMaps={activeJudgeInfo?.originalMaps}
                    isUserFetched={!!activeTab?.id}
                    userMaps={activeJudgeInfo?.userMaps}
                    bio={activeJudgeInfo?.bio}
                    designPreference={activeJudgeInfo?.design_preferences}
                    loveAboutHalo={activeJudgeInfo?.love_about_halo}
                    isPreview={false}
                    setActiveJudge={setActiveTab}
                    contestRelation={contestRelation}
                    closeJudgesBio={closeJudgesBio}
                    judgeState={activeJudgeInfo?.state}
                    contestId={contestId}
                  />
                </MainSwipeableDrawer>
              </Else>
            </If>
          </When>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
        >
          {judges.map((judge) => (
            <UserCard
              key={judge.id}
              id={judge.user_id}
              judgeId={judge.judge_id}
              alt={judge.login}
              src={userImageSelector(judge.user_images, PROFILE_IMAGE_TYPE.AVATAR, 'medium')}
              name={judge.login}
              mapsCount={judge?.maps_uploaded}
              description={`${judge.firstName || ''} ${judge.secondName || ''}`}
              isJudge={isJudge}
              isPublishedRound={isPublishedRound}
              isPreview={isPreview}
              contestRelation={contestRelation}
            />
          ))}
        </Box>
        {showModal && (
          <JudgesModal
            showModal={showModal}
            setShowModal={setShowModal}
            contestId={contestId}
            judges={judges}
            ownerId={ownerId}
            contest={contest}
          />
        )}
      </Box>
    )
  )
}

export default ContestJudgesList
